import React from 'react';
import type { TranscriptRevision } from '../types/portal';
import { formatEditStamp } from '../utils/time';
interface TranscriptVersionsProps {
  /** Every saved state, oldest first. The first is the original upload. */
  revisions: TranscriptRevision[];
  selectedId: string;
  onSelect: (id: string) => void;
}

/** Compact list of saved transcript versions. One row is VIEWING at a time. */
export function TranscriptVersions({
  revisions,
  selectedId,
  onSelect
}: TranscriptVersionsProps) {
  if (revisions.length < 2) return null;
  const rows = [...revisions].reverse();
  return <ul className="m-0 list-none border-t border-rule p-0" data-id="element-457" data-mp="1ijmwi259zhp">
      {rows.map((revision, index) => {
      const viewing = revision.id === selectedId;
      const original = index === rows.length - 1;
      const label = original ? 'Original Transcript' : index === 0 ? 'Latest Edit' : 'Previous Edit';
      return <li key={revision.id} className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-2 border-b border-rule py-4" data-id="element-458" data-mp="y17nllfz7vrf" data-mpi={index}>
            <span className="label-sm text-charcoal" data-id="element-459" data-mp="1zh6nz4psq3on">
              <span className={viewing ? 'text-ink' : 'text-mute'} data-id="element-460" data-mp="1ziq50xja0irh">{label}</span>
              {!original && <>
                  {' — '}
                  {revision.editorName} · {formatEditStamp(revision.at)}
                </>}
            </span>
            <button type="button" onClick={() => onSelect(revision.id)} aria-current={viewing} disabled={viewing} className={['label transition-colors duration-150 ease-out', viewing ? 'text-ink' : 'text-mute hover:text-ink'].join(' ')} data-id="element-461" data-mp="2n56afsg2r7xf">
              {viewing ? 'Viewing' : 'View'}
            </button>
          </li>;
    })}
    </ul>;
}